import { ComponentPropsWithoutRef, FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from 'src/components/Grid/grid.less';

type MColumns = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14';
type LColumns = MColumns | '15' | '16';

interface GridColumnProps extends ComponentPropsWithoutRef<'div'> {
    m: MColumns;
    l: LColumns;
    noPrint?: boolean;
    flex?: boolean;
}

const M_COLUMN_TO_CSS_CLASS = {
    0: styles.gridColumnM0,
    1: styles.gridColumnM1,
    2: styles.gridColumnM2,
    3: styles.gridColumnM3,
    4: styles.gridColumnM4,
    5: styles.gridColumnM5,
    6: styles.gridColumnM6,
    7: styles.gridColumnM7,
    8: styles.gridColumnM8,
    9: styles.gridColumnM9,
    10: styles.gridColumnM10,
    11: styles.gridColumnM11,
    12: styles.gridColumnM12,
    13: styles.gridColumnM13,
    14: styles.gridColumnM14,
};

const L_COLUMN_TO_CSS_CLASS = {
    0: styles.gridColumnL0,
    1: styles.gridColumnL1,
    2: styles.gridColumnL2,
    3: styles.gridColumnL3,
    4: styles.gridColumnL4,
    5: styles.gridColumnL5,
    6: styles.gridColumnL6,
    7: styles.gridColumnL7,
    8: styles.gridColumnL8,
    9: styles.gridColumnL9,
    10: styles.gridColumnL10,
    11: styles.gridColumnL11,
    12: styles.gridColumnL12,
    13: styles.gridColumnL13,
    14: styles.gridColumnL14,
    15: styles.gridColumnL15,
    16: styles.gridColumnL16,
};

const GridColumn: FC<GridColumnProps & PropsWithChildren> = ({ m, l, noPrint, flex, children, ...otherProps }) => {
    return (
        <div
            {...otherProps}
            className={classnames(styles.gridColumn, {
                [M_COLUMN_TO_CSS_CLASS[m]]: m,
                [L_COLUMN_TO_CSS_CLASS[l]]: l,
                [styles.gridColumnNoPrint]: noPrint,
                [styles.gridColumnFlex]: flex,
            })}
        >
            {children}
        </div>
    );
};
export default GridColumn;
